import { useEffect, useState } from "react";
import { api, getAddressOfOrder, getCountries, getTicketTypeById, getTicketTypeInfosByTicketTypeId, getOccupancy, getSeatBySeatId } from "ticketino-api-client";
import axios from 'axios';

import { Cart, XLg } from "react-bootstrap-icons";

import Loading from "./Loading";

/* eslint eqeqeq: "off" */


const Summary = (props) => {

    //----variables----

    //developement env dependent
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;

    //prop values
    const orderId = props.orderId;
    const token = props.token;
    const selectedFields = props.selectedFields;
    const changeLanguage = props.changeLanguage;
    const selectedLanguage = props.languageISO;
    const selectedLanguageCode = props.languageCode;
    const ticketTypesInformation = props.ticketTypesInformation;

    //-----mutateable
    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);
    const [address, setAddress] = useState();

    const [loading, setLoading] = useState(true);
    const [resources, setResources] = useState([]);

    const [errorMessage, setErrorMessage] = useState("");
    const [neededFields, setNeededFields] = useState([]);
    const [countryArray, setCountryArray] = useState([]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        api.defaults.baseURL = baseUrl;

        if (selectedFields == null) {
            setNeededFields(["firstName", "name", "countryId", "postCode", "city", "salutation", "street", "deliveryAddress"])
        } else {
            setNeededFields(selectedFields.split(";"));
        }

        scrollView();
        loadOrder(orderId);
    }, []);

    useEffect(() => {
        requestResources(selectedLanguage);
        loadCountries(selectedLanguage);
    }, [selectedLanguage]);

    const requestResources = async (langauge) => {
        await axios
            .get(`${baseProxyUrl}/resources/${langauge}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            const order = await getOrderByOrderId(orderId);
            const updatedAddress = await getAddressOfOrder(orderId);

            if (order) {
                const tickets = await getTicketsByOrderId(orderId);

                const updatedTickets = await Promise.all(
                    tickets.map(async (ticket) => {
                        const ticketType = ticketTypesInformation.find((tti) => tti.id == ticket.ticketTypeId) ?? await getTicketTypeById(ticket.ticketTypeId);
                        const info = ticketTypesInformation.find((tti) => tti.id == ticket.ticketTypeId)?.info ?? await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);

                        let seatDetails = {};
                        if (ticket.occupancyId != null && ticket.occupancyId > 0) {
                            let occupancy = await getOccupancy(ticket.occupancyId);
                            if (occupancy) {
                                seatDetails = await getSeatBySeatId(occupancy.seatId);
                            }
                        }
                        return { ...ticket, ticketType: ticketType, info: info, seatDetails: seatDetails }
                    })
                )

                setOrder(order)
                setAddress({ ...updatedAddress });
                setTickets(updatedTickets);

                setLoading(false);
            } else {
                props.changeOrderId(0);
                props.changePage(-1);
            }

        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }

    const loadCountries = async (language) => {
        try {
            let countries = await getCountries(language.trim());

            const indexCH = countries.findIndex(c => c.id === 176);
            const ch = countries[indexCH];
            countries.splice(indexCH, 1);

            var indexDE = countries.findIndex(c => c.id === 229);
            const de = countries[indexDE];
            countries.splice(indexDE, 1);

            var indexAU = countries.findIndex(c => c.id === 228);
            const au = countries[indexAU];
            countries.splice(indexAU, 1);

            countries.unshift({ id: 0, name: "---------" });
            countries.unshift(au);
            countries.unshift(de);
            countries.unshift(ch);

            setCountryArray(countries);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getTicketsByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}/Tickets`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const removeTicketFromBasket = async (ticketId) => {
        let removeTicketBody = {
            "TicketsToRemove": [
                ticketId
            ]
        }

        await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`,
            {
                headers: { Accept: "application/json", },
                data: removeTicketBody
            })
            .then(() => {
                loadOrder(orderId);
            }).catch((err) => {
                setErrorMessage(resources.summarypage?.generalError);
            })
    }

    const scrollView = () => {
        var scrollElement = document.getElementById("ticketinoScrollElement");

        if (scrollElement) {
            scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    //change the user selected langauge
    const updateLanguage = (language) => {
        requestResources(language);
        changeLanguage(language)
    }

    const onSubmit = () => {
        if (tickets.length > 0) {
            props.changePage(1)
        } else {
            setErrorMessage(resources.summarypage?.noTicketSelectedError)
        }
    }

    const languageSelectDiv = () => {
        return (
            <div className="container mb-3">
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <select
                            className="ticketinoSelect selectNum form-select"
                            aria-label=""
                            value={selectedLanguage}
                            onChange={(e) => {
                                updateLanguage(e.currentTarget.value);
                            }}>
                            <option value={"en"} key={1} >{"en"}</option>
                            <option value={"de"} key={2} >{"de"}</option>
                            <option value={"fr"} key={3} >{"fr"}</option>
                            <option value={"it"} key={4} >{"it"}</option>

                        </select>
                    </div>
                    <div className="col-auto">
                        <div type="button" className="btn btn-light position-relative fs-6">
                            <Cart />
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {tickets?.length}
                            </span>
                        </div>
                    </div>
                </div>
                <p className="ticketinoText text titleStyle text-start text-center fs-3 fw-semibold mb-2">{resources.summarypage?.title}</p>
                <p className="ticketinoText text fs-6 text-center">{resources.summarypage?.instruction}</p>
                {(!(tickets?.length > 0) & !loading) ? <div>
                    <div className="alert alert-danger" role="alert">
                        {resources.summarypage?.noTicketSelectedError}
                    </div>
                    <div className="flex-end mb-5 col text-center">
                        <button className="ticketinoButton btn mx-2 button btn-light" onClick={() => props.changePage(-2)} >
                            {resources.customerPage?.buttonLabelNewBooking}
                        </button>
                    </div>
                </div> : null}
                {(!(order.id) && !loading) ? <div className="alert alert-warning" role="alert">
                    {resources.summarypage?.reserveTicket}
                </div> : null}
            </div>
        )
    }

    const mapTickets = () => {

        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets];
        }

        ticketsSorted = ticketsSorted.map((ticket) => {
            const ticketTypeInfo = ticket.info?.find(info => info.languageId === selectedLanguageCode) ?? ticket.info?.find(info => info.languageId === 0);

            //taking the default value when info doesnt exist
            return { ...ticket, info: ticketTypeInfo };
        });

        return (
            <ul className="list-group ms-0 me-0">
                {
                    tickets.length > 0 && ticketsSorted.map((ticket, key) => (
                        <li className="list-group-item" key={key}>
                            <div className="row m-0 p-1 tickets">
                                <div className="col-md-8 col-7 text-start">
                                    {ticket.info?.name}
                                    {ticket.seatDetails && Object.keys(ticket.seatDetails).length > 0 && <div className="form-text">{resources.summarypage?.SeatingPlace}: {resources.summarypage?.Row} {ticket.seatDetails.rowName}, {resources.summarypage?.Seat} {ticket.seatDetails.name}</div>}
                                </div>
                                <div className="col-md-3 col-4 text-end">
                                    {ticket.currency} {ticket.price?.toFixed(2)}
                                </div>
                                <div className="col-md-1 col-1 text-end">
                                    <XLg onClick={() => removeTicketFromBasket(ticket.id)} />
                                </div>
                            </div>
                        </li>
                    ))
                }
            </ul>
        )
    }

    //----HTML Display
    return (
        <div className="page-container">
            <section className="section" id="sectionTicket">
                <div className="box-main row">
                    <div className="firsthalf">
                        {languageSelectDiv()}
                        {loading ? <Loading /> : tickets?.length > 0 ?
                            <div className="container">
                                <div className="customerInformation">
                                    {neededFields.includes("company") &&
                                        <div className="row">
                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelCompany}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">{address?.company}</p>
                                            </div>
                                        </div>
                                    }
                                    {neededFields.includes("salutation") &&
                                        <div className="row">
                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelGender}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">{address?.salutation}</p>
                                            </div>
                                        </div>
                                    }
                                    {neededFields.includes("firstName") &&
                                        <div className="row">
                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelFirstname}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">{address?.firstName}</p>
                                            </div>
                                        </div>
                                    }
                                    {neededFields.includes("name") &&

                                        <div className="row">
                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelFamilyname}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">{address?.name}</p>
                                            </div>
                                        </div>
                                    }

                                    <div className="row">

                                        <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelEmail}</p>
                                        <div className="col-8">
                                            <p className="ticketinoText text fs-6 text-dark">{address?.email}</p>
                                        </div>
                                    </div>
                                    {neededFields.includes("street") &&

                                        <div className="row">

                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelStreet}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">{address?.street}</p>
                                            </div>
                                        </div>
                                    }
                                    {(neededFields.includes("postCode") || neededFields.includes("city")) &&

                                        <div className="row">
                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelPlz}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">
                                                    {address?.postCode} {address?.city}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    <div className="row">
                                        <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelCountry}</p>
                                        <div className="col-8">
                                            <p className="ticketinoText text fs-6 text-dark">
                                                {countryArray.length > 0 &&
                                                    <>
                                                        {countryArray?.find((country) => country.id == address?.countryId)?.name}
                                                    </>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                    {neededFields.includes("telephone") &&

                                        <div className="row">
                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelTelephone}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">
                                                    {address?.telephone}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    {neededFields.includes("mobile") &&

                                        <div className="row">
                                            <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelmobile}</p>
                                            <div className="col-8">
                                                <p className="ticketinoText text fs-6 text-dark">
                                                    {address?.mobile}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    <div className="row">
                                        <p className="ticketinoLabel col-md-2 col-4 text fs-6 text-dark fw-semibold">{resources.summarypage?.labelTotal}</p>
                                        <div className="col-8">
                                            <p className="ticketinoText text fs-6 text-dark">
                                                {order?.totalPrice} {order?.currency}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="ticketSummary row mt-4 mb-3">
                                        <div className="col-12">
                                            {mapTickets()}
                                        </div>
                                    </div>
                                </div>
                                <div className="container gap-3">
                                    <div id="ticketinoErrorMessage" className="ticketinoText ticketinoError text fs-6 text-center mb-5 row">
                                        {errorMessage}
                                    </div>
                                </div>

                                <button className="button btn-grey btn-ticketino-large mb-3" onClick={() => props.changePage(-1)}>{resources.summarypage?.buttonLabelPrevious}</button>
                                <button className="button btn-orange btn-ticketino-large  float-end" disabled={!(tickets?.length > 0)} onClick={onSubmit}>{resources.summarypage?.buttonLabelContinue}</button>
                            </div> : null}
                    </div>
                </div>
            </section>
        </div>

    )
}

export default Summary